import { OrganizationTypeEnum } from "@/api/model";
import { ROUTE_NAME } from "@/shared/constants/routes";

/**
 * Route an admin lands on after login / when visiting "/":
 * network admins go to Network Management, club organizations go to the
 * Schedule tab (MAI-4748), everyone else goes to the Feed.
 */
export function getDefaultLandingRouteName(
  organizationType?: OrganizationTypeEnum
): string {
  if (organizationType === OrganizationTypeEnum.network) {
    return ROUTE_NAME.NETWORK_MANAGEMENT;
  }
  if (organizationType === OrganizationTypeEnum.club) {
    return ROUTE_NAME.SCHEDULE;
  }
  return ROUTE_NAME.FEED;
}
